import { useNavigate } from "react-router-dom";
import { User, LogOut, UserCircle, Settings, Monitor, Coins } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useAuth } from "@/hooks/useAuth";

interface UserMenuProps {
  profile: any;
  session: any | null;
}

export const UserMenu = ({ profile, session }: UserMenuProps) => {
  const navigate = useNavigate();
  const { signOut } = useAuth();
  const handleLogout = async () => {
    try {
      await signOut();
      window.location.reload();
      return
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  return (
    <div className="flex items-center">
      {profile?.credits !== undefined && (
        <Button 
          variant="ghost" 
          size="sm" 
          className="mr-2 flex items-center gap-2 bg-gray-100 px-3 py-1.5 rounded-full text-sm font-medium text-gray-700 border border-gray-200 shadow-sm hover:bg-gray-200 transition-colors"
          onClick={() => navigate('/dashboard/credits')}
          title="View your credits and purchase more"
        >
          <Coins className="h-4 w-4 text-amber-500 flex-shrink-0" />
          <span>{profile.credits} Credits</span>
        </Button>
      )}
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" className="flex items-center">
            <User className="h-5 w-5 mr-2" />
            <span className="flex items-center gap-1 max-w-[160px] truncate">
              <span className="truncate">{profile?.full_name || profile.email}</span>
              {profile?.subscription?.status == 'active' && (
                <div className="px-1.5 py-0.5 bg-gradient-to-r from-amber-500 to-amber-700 text-white border-0 text-xs font-bold rounded-full flex-shrink-0">
                  PRO
                </div>
              )}
            </span>
          </Button>
        </DropdownMenuTrigger>
      <DropdownMenuContent 
        align="end" 
        className="w-56 bg-white border border-gray-200 shadow-lg z-50"
      >
        <DropdownMenuItem 
          onClick={() => navigate('/dashboard')}
          className="hover:bg-primary hover:text-white cursor-pointer"
        >
          <Monitor className="mr-2 h-4 w-4" />
          <span>Dashboard</span>
        </DropdownMenuItem>
        <DropdownMenuItem 
          onClick={() => navigate('/dashboard/settings')}
          className="hover:bg-primary hover:text-white cursor-pointer"
        >
          <Settings className="mr-2 h-4 w-4" />
          <span>Settings</span>
        </DropdownMenuItem>
        <DropdownMenuItem 
          onClick={() => navigate("/dashboard/profile")}
          className="hover:bg-primary hover:text-white cursor-pointer"
        >
          <UserCircle className="mr-2 h-4 w-4" />
          <span>Profile</span>
        </DropdownMenuItem>
        <DropdownMenuItem 
          onClick={handleLogout}
          className="hover:bg-primary hover:text-white cursor-pointer"
        >
          <LogOut className="mr-2 h-4 w-4" />
          <span>Log out</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
    </div>
  );
};